class DitecEffectController
{

    constructor()
    {
        const options = {
            //rootMargin: document.documentElement.getAttribute('data-effects-root-margin') || '-15% 0px -15% 0px',
            //threshold: document.documentElement.getAttribute('data-effects-threshold') || .15
            rootMargin: '0px',
            threshold: 1.0
        };

        const delay = 250;
        let delayIteration = 0;

        try {
            this.intersectionObserver = new IntersectionObserver(entries => {
                entries.forEach(entry => {
                    if (entry.intersectionRatio > 0) {
                        const element = entry.target;
                        const video = entry.target.parentNode.querySelector('video');
                        const additionalDelay = video ? 1750 : 0; // Play video first, show text a little bit later
                        if (!element.hasAttribute('data-effects-applied')) {
                            const timeout = delayIteration * delay + additionalDelay;
                            delayIteration ++;
                            setTimeout(() => {
                                element.setAttribute('data-effects-applied', 1);
                                this.intersectionObserver.unobserve(element);
                            }, timeout);
                        }
                    }
                });
            }, options);
        }

        catch (error) {
            console.error(error);
        }

        window.addEventListener('scroll', () => delayIteration = 0);
    }

    /**
     * Update elements with effects and start observing them
     */
    update()
    {
        const elementsWithEffects = document.querySelectorAll('.tabslider__item__text');
        if (!elementsWithEffects) {
            return;
        }
        elementsWithEffects.forEach(element => {
            this.intersectionObserver.observe(element);
        });
    }

}

export default DitecEffectController;